export const ROUTE_PATHS = { HOME: '/' };

export type TripType = 'party' | 'wellness' | 'adventure' | 'beach' | 'cultural' | '';

export interface SurveyData {
  // Contact
  name: string; email: string; instagram: string; referral: string;
  // Group
  groupSize: string; ageRange: string[]; groupRelationship: string;
  occasion: string; travelExperience: string;
  // Trip Logistics
  preferredDates: string; flexibility: string; duration: string;
  hasDestination: string; destinationIdeas: string; internationalOk: string;
  avoidDestinations: string;
  // Budget
  budgetPerPerson: string; budgetIncludes: string[]; groupFund: string;
  // Accommodation
  accommodationType: string[]; roomSharing: string; amenities: string[];
  // Vibe & Trip Type
  tripType: TripType; overallVibe: string; topPriorities: string[];
  // Party specific
  nightlifeTypes: string[]; nightOutBudget: string; drinkingStatus: string;
  vipPreferences: string[]; nightOutFrequency: string; dayParties: string;
  specificPartyEvents: string; dressCode: string;
  // Wellness specific
  wellnessActivities: string[]; wellnessIntention: string; nutritionFocus: string;
  activityLevel: string; healthNotes: string; wellnessSetting: string;
  // Adventure specific
  adventureActivities: string[]; adventureLevel: string; adventureLimitations: string;
  natureSetting: string[]; guidePreference: string; adventureDays: string; adventureDowntime: string;
  // Beach specific
  beachActivities: string[]; beachEnvironment: string; poolVsBeach: string;
  beachClubImportance: string; beachSpaAddOn: string;
  // Cultural / Foodie specific
  foodExperiences: string[]; diningBoldness: string;
  culturalActivities: string[]; culturalDepth: string; culturalInterests: string;
  // Dining (Step 6)
  dietaryRestrictions: string[]; dietaryOther: string;
  diningExperiences: string[]; mealStructure: string; cuisinePrefs: string;
  diningBudget: string; drinkPrefs: string[]; privateChef: string; diningNotes: string;
  // Final (Step 7)
  transportPrefs: string; airportTransfer: string;
  groupDynamics: string; isSurprise: string;
  specialAccommodations: string; itineraryDeadline: string;
  referralSource: string; finalNotes: string;
}

export const initialData: SurveyData = {
  name:'', email:'', instagram:'', referral:'',
  groupSize:'', ageRange:[], groupRelationship:'', occasion:'', travelExperience:'',
  preferredDates:'', flexibility:'', duration:'', hasDestination:'', destinationIdeas:'',
  internationalOk:'', avoidDestinations:'',
  budgetPerPerson:'', budgetIncludes:[], groupFund:'',
  accommodationType:[], roomSharing:'', amenities:[],
  tripType:'', overallVibe:'', topPriorities:[],
  nightlifeTypes:[], nightOutBudget:'', drinkingStatus:'',
  vipPreferences:[], nightOutFrequency:'', dayParties:'', specificPartyEvents:'', dressCode:'',
  wellnessActivities:[], wellnessIntention:'', nutritionFocus:'', activityLevel:'', healthNotes:'', wellnessSetting:'',
  adventureActivities:[], adventureLevel:'', adventureLimitations:'', natureSetting:[], guidePreference:'', adventureDays:'', adventureDowntime:'',
  beachActivities:[], beachEnvironment:'', poolVsBeach:'', beachClubImportance:'', beachSpaAddOn:'',
  foodExperiences:[], diningBoldness:'', culturalActivities:[], culturalDepth:'', culturalInterests:'',
  dietaryRestrictions:[], dietaryOther:'',
  diningExperiences:[], mealStructure:'', cuisinePrefs:'',
  diningBudget:'', drinkPrefs:[], privateChef:'', diningNotes:'',
  transportPrefs:'', airportTransfer:'',
  groupDynamics:'', isSurprise:'',
  specialAccommodations:'', itineraryDeadline:'',
  referralSource:'', finalNotes:'',
};

export const TRIP_TYPES = [
  { id: 'party',    label: 'Party & Nightlife',   emoji: '🥂', desc: 'Bachelorettes, birthdays, girls trips, VIP tables, beach clubs, and all the vibes' },
  { id: 'wellness', label: 'Wellness & Spa',       emoji: '🧘', desc: 'Spa retreats, yoga, rest and recovery, healthy eating, and intentional relaxation' },
  { id: 'adventure',label: 'Adventure & Nature',   emoji: '🏔️', desc: 'Zip-lining, hiking, snorkeling, wildlife, national parks, and outdoor exploration' },
  { id: 'beach',    label: 'Beach & Relaxation',   emoji: '🏖️', desc: 'Sun, sand, ocean, beach bars, boat days, and doing absolutely nothing' },
  { id: 'cultural', label: 'Cultural & Foodie',    emoji: '🍜', desc: 'Local cuisine, art, history, markets, cooking classes, and authentic experiences' },
];

export const STEPS = [
  { id: 1, label: 'Trip Type'   },
  { id: 2, label: 'Your Group'  },
  { id: 3, label: 'Logistics'   },
  { id: 4, label: 'Budget'      },
  { id: 5, label: 'Deep Dive'   },
  { id: 6, label: 'Dining'      },
  { id: 7, label: 'Final Details'},
];
